export function onOffline(callback: (ev: Event) => void) {
    addEventListener("offline", callback);
}

export function onOnline(callback: (ev: Event) => void) {
    addEventListener("online", callback);
}

export function onChange(callback: (ev: Event) => void) {
    onOffline(callback);
    onOnline(callback);
}

onChange((ev) => console.log(ev.type));
